import React from 'react';
import {
  Accessibility,
  Armchair,
  PackageCheck,
  Bike,
  Car,
  ShoppingBag,
  UtensilsCrossed,
  Clock,
  Leaf,
  Star,
  Users,
  CreditCard
} from 'lucide-react';
import { services } from '../data/mockData';

const iconMap = {
  Accessibility,
  Armchair,
  PackageCheck,
  Bike,
  Car,
  ShoppingBag,
  UtensilsCrossed,
  Clock,
  Leaf,
  Star,
  Users,
  CreditCard
};

const Services = () => {
  return (
    <section id="services" className="py-24 bg-black">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2
            className="text-5xl lg:text-6xl font-bold text-white mb-4"
            style={{ fontFamily: 'Crimson Text, serif' }}
          >
            Nos <span className="text-[#D4AF37]">Services</span>
          </h2>
          <p className="text-xl text-white/70 max-w-2xl mx-auto">
            Pour votre confort et votre satisfaction
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div
                key={index}
                className="bg-white/5 backdrop-blur-sm p-6 rounded-xl border border-white/10 hover:border-[#D4AF37] hover:bg-white/10 transition-all duration-300 group"
              >
                <div className="flex items-start space-x-4">
                  <div className="bg-[#D4AF37] p-3 rounded-lg group-hover:scale-110 transition-transform duration-300">
                    {IconComponent && <IconComponent size={24} className="text-black" />}
                  </div>
                  <div className="flex-1">
                    <h3 className="font-bold text-white mb-1 group-hover:text-[#D4AF37] transition-colors">
                      {service.title}
                    </h3>
                    <p className="text-sm text-white/70">{service.description}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Additional Info */}
        <div className="mt-16 grid md:grid-cols-3 gap-6">
          <div className="bg-[#D4AF37]/10 backdrop-blur-sm p-8 rounded-xl border-2 border-[#D4AF37] text-center">
            <div className="text-4xl font-bold text-[#D4AF37] mb-2">100%</div>
            <div className="text-white font-semibold">Halal certifié</div>
          </div>
          <div className="bg-[#D4AF37]/10 backdrop-blur-sm p-8 rounded-xl border-2 border-[#D4AF37] text-center">
            <div className="text-4xl font-bold text-[#D4AF37] mb-2">1-10€</div>
            <div className="text-white font-semibold">Prix par personne</div>
          </div>
          <div className="bg-[#D4AF37]/10 backdrop-blur-sm p-8 rounded-xl border-2 border-[#D4AF37] text-center">
            <div className="text-4xl font-bold text-[#D4AF37] mb-2">4.6/5</div>
            <div className="text-white font-semibold">Note moyenne</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
